import React, { useEffect, useState } from 'react';
export function StickyCta() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const hero = document.getElementById('hero');
    if (!hero) return;
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(!entry.isIntersecting);
    }, {
      threshold: 0.1
    });
    observer.observe(hero);
    return () => {
      observer.unobserve(hero);
    };
  }, []);
  return <div className={`fixed bottom-0 left-0 right-0 max-w-[480px] mx-auto bg-[#1C1A17]/95 backdrop-blur-[12px] pt-3 px-5 pb-5 border-t border-white/10 z-[100] transition-transform duration-400 ease-[cubic-bezier(0.16,1,0.3,1)] ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-256">
      <div className="flex items-center gap-3" data-id="element-257">
        <div className="flex-1" data-id="element-258">
          <div className="font-serif text-[24px] font-semibold text-white leading-none" data-id="element-259">
            $24.990
          </div>
          <div className="text-[10px] text-white/40 mt-0.5" data-id="element-260">
            Acceso inmediato · Pago único
          </div>
        </div>
        <a href="https://www.soportesaberdigital.com/cart/49527567057135:1" target="_blank" rel="noopener noreferrer" className="bg-terra text-white text-[13px] font-bold py-3.5 px-5 rounded-lg no-underline whitespace-nowrap shadow-[0_4px_16px_rgba(184,92,56,0.4)]" data-id="element-261">
          Comprar →
        </a>
      </div>
    </div>;
}